import React from 'react';
import styled, { css } from 'styled-components';

import Button from '../Button';
import { Body, Heading4, Variant } from '../Typography/index';
import icons from '../Icon/components';
import JustificationContainer from '../JustificationContainer';
import TEST_ID from './index.testid';

export type Props = {
  dataTestId?: string;
  heading: string;
  description: React.ReactNode;
  label: string;
  onAdd: () => void;
  icon?: keyof typeof icons;
  disabled?: boolean;
};

const AddAPIBlock: React.FC<Props> = ({
  dataTestId,
  heading,
  onAdd,
  label,
  icon = 'plus',
  description,
  disabled = false,
  ...rest
}) => (
  <Container data-testid={dataTestId} $disabled={disabled} {...rest}>
    <Heading4
      wordBreak="break-all"
      color={{ group: 'primary' }}
      withoutMargin
      variant={Variant.primary}
    >
      {heading}
    </Heading4>
    <Description size="base" margin={['xxs', null, 'm', null]}>
      {description}
    </Description>
    <StyledButton
      onClick={onAdd}
      size="medium"
      appearance="primary"
      label={label}
      icon={icon}
      disabled={disabled}
      dataTestId={TEST_ID.ADD_BUTTON}
    />
  </Container>
);

const Container = styled(JustificationContainer)<{ $disabled?: boolean }>(
  ({ theme, $disabled }) => css`
    background-color: ${theme.color('primary', 'translucent')};
    flex-direction: column;
    border-radius: ${theme.getTokens().border.radius.base};
    padding: ${theme.space('m')};

    opacity: ${$disabled ? 0.5 : 1};
  `,
);

const Description = styled(Body)<{}>`
  display: flex;
  flex: 0 1;
  height: 100%;
`;

const StyledButton = styled(Button)<{}>`
  width: 100%;
  height: 100%;
  justify-content: flex-start;
`;

export default AddAPIBlock;
